import Messages from "./components/messages";

function App() {
  return <Messages />;
}

export default App;
